(() => {
  const init = (root) => {
    if (root.dataset.ebfmReady) return;
    root.dataset.ebfmReady = 'true';
    const grid = root.querySelector('[data-product-grid]');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-ebfm-card]')];
    const search = root.querySelector('[data-search]');
    const sort = root.querySelector('[data-sort]');
    const count = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-empty]');
    const toast = root.querySelector('[data-toast]');
    const filters = [...root.querySelectorAll('[data-filter]')];
    let active = 'all';
    let toastTimer;
    const announce = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => { toast.hidden = true; }, 3000);
    };
    const infinite = root.dataset.infinite === 'true';
    const batchSize = Number(root.dataset.batchSize) || 8;
    let limit = infinite ? batchSize : cards.length;
    let matches = [];
    const stories = [...grid.querySelectorAll('[data-ebfm-story]')];
    const loadRegion = root.querySelector('[data-load-region]');
    const loadMore = root.querySelector('[data-load-more]');
    const loadProgress = root.querySelector('[data-load-progress]');
    const loadEnd = root.querySelector('[data-load-end]');
    const sentinel = root.querySelector('[data-scroll-sentinel]');
    const refresh = (reset = true) => {
      if (reset) limit = infinite ? batchSize : cards.length;
      const term = (search?.value || '').trim().toLocaleLowerCase('ro-RO');
      matches = cards.filter(card => (active === 'all' || card.dataset.category === active) && (!term || card.querySelector('h3').textContent.toLocaleLowerCase('ro-RO').includes(term)));
      const mode = sort?.value || 'featured';
      if (mode === 'price-asc') matches.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
      if (mode === 'price-desc') matches.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
      if (mode === 'name') matches.sort((a, b) => a.querySelector('h3').textContent.localeCompare(b.querySelector('h3').textContent, 'ro'));
      cards.forEach(card => { card.hidden = true; });
      stories.forEach(story => { story.hidden = true; });
      matches.forEach((card, index) => {
        card.hidden = index >= limit;
        grid.insertBefore(card, empty);
        if (active === 'all' && !term && mode === 'featured') {
          stories.filter(story => Number(story.dataset.after) === index + 1).forEach(story => {
            story.hidden = index >= limit;
            grid.insertBefore(story, empty);
          });
        }
      });
      const shown = Math.min(limit, matches.length);
      if (count) count.textContent = `${matches.length} ${matches.length === 1 ? 'produs' : 'produse'}`;
      if (empty) empty.hidden = matches.length > 0;
      if (loadRegion) loadRegion.hidden = !matches.length;
      if (loadProgress) loadProgress.textContent = `${shown} din ${matches.length} produse`;
      if (loadMore) loadMore.hidden = shown >= matches.length;
      if (sentinel) sentinel.hidden = shown >= matches.length;
      if (loadEnd) loadEnd.hidden = shown < matches.length;
    };
    const selectCategory = (category) => {
      active = category;
      filters.forEach(item => {
        const selected = item.dataset.filter === active;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      refresh();
    };
    filters.forEach(button => button.addEventListener('click', () => selectCategory(button.dataset.filter)));
    root.querySelectorAll('[data-browse-category]').forEach(button => button.addEventListener('click', () => {
      if (search) search.value = '';
      if (sort) sort.value = 'featured';
      selectCategory(button.dataset.browseCategory);
      const control = filters.find(item => item.dataset.filter === active);
      control?.focus({preventScroll: true});
      root.querySelector('.ebfm-controls')?.scrollIntoView({block: 'start', behavior: 'instant'});
    }));
    search?.addEventListener('input', () => refresh());
    sort?.addEventListener('change', () => refresh());
    const reveal = (manual = false) => {
      if (limit >= matches.length) return;
      const firstNew = matches[limit];
      limit += batchSize;
      refresh(false);
      if (manual) firstNew?.querySelector('h3 a')?.focus({preventScroll: true});
    };
    loadMore?.addEventListener('click', () => reveal(true));
    let observer;
    if (infinite && sentinel && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) reveal();
      }, {rootMargin: '0px 0px 240px 0px'});
      observer.observe(sentinel);
    }
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer?.disconnect();
    });
    root.querySelectorAll('[data-add-to-cart]').forEach(button => button.addEventListener('click', async () => {
      if (button.disabled || button.dataset.busy) return;
      const original = button.innerHTML;
      button.dataset.busy = 'true';
      button.disabled = true;
      button.textContent = 'Se adaugă…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:Number(button.dataset.variantId),quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Produsul nu a putut fi adăugat. Verifică pagina produsului.');
        button.textContent = 'Adăugat ✓';
        announce('Produsul a fost adăugat în coș.');
        try {
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {credentials:'same-origin',headers:{'Accept':'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); el.hidden = cart.item_count === 0; });
          }
        } catch { /* Cart confirmation remains visible if the count refresh fails. */ }
        setTimeout(() => { button.innerHTML = original; button.disabled = false; delete button.dataset.busy; }, 1700);
      } catch (error) {
        announce(error.message || 'A apărut o problemă. Încearcă din nou.');
        button.innerHTML = original;
        button.disabled = false;
        delete button.dataset.busy;
      }
    }));
    const time = root.querySelector('[data-ebfm-time]');
    if (time) {
      const tick = () => {
        const now = new Date();
        time.textContent = new Intl.DateTimeFormat('ro-RO', {hour:'2-digit',minute:'2-digit',timeZone:'Europe/Bucharest'}).format(now);
        const face = root.querySelector('.ebfm-clock-art__face');
        if (face) {
          const hour = now.toLocaleString('en-US',{hour:'numeric',hour12:false,timeZone:'Europe/Bucharest'}) % 12;
          const minute = Number(now.toLocaleString('en-US',{minute:'numeric',timeZone:'Europe/Bucharest'}));
          face.style.setProperty('--hour-angle', `${hour * 30 + minute / 2}deg`);
          face.style.setProperty('--minute-angle', `${minute * 6}deg`);
        }
      };
      tick();
      const timer = setInterval(tick, 30000);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) clearInterval(timer); });
    }
    refresh();
  };
  document.querySelectorAll('[data-ebfm-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ebfm-root]').forEach(init));
})();
